export default function Footer() {
  return <footer className="footer wrap">
    <span>Stewart Software Solutions · Seattle, WA</span>
    <a href="https://www.linkedin.com/in/benjuhminstewart/" target="_blank" rel="noopener noreferrer">Connect on LinkedIn ↗</a>
  </footer>;
}
